import qs from "qs";

class FetchError extends Error {
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}

async function otherFetch({
  url,
  method,
  body = undefined,
  headers = {},
  params = undefined,
  responseType,
}) {
  if (params) {
    url = `${url}?${new URLSearchParams(params)}`;
  }

  const config = {
    method,
    headers: Object.assign({}, headers, {
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    }),
  };

  if (body) {
    config.body = body;
  }

  try {
    const response = await fetch(url, config);
    const x = await response[responseType]();
    if (!response.ok && !response.redirected) {
      response.data = x;
      const msg = (x && (x.error || x.errors)) || response.statusText;
      throw new FetchError(msg, response);
    } else {
      response.data = x;
      return response;
    }
  } catch (ex) {
    NApp.flashNoticeOut(ex.toString(), "error", 0);
    throw ex;
  }
}

async function jsonFetch({
  url,
  method,
  body = undefined,
  headers = {},
  params = undefined,
  showMessageOnError = true,
}) {
  if (params) {
    url = `${url}?${qs.stringify(params, { encode: false, arrayFormat: 'brackets' })}`;
  }

  const config = {
    method,
    headers: Object.assign({}, headers, {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    }),
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, config);
    const json = await response.json();
    if (!response.ok && !response.redirected) {
      response.data = json;
      const msg = json.error || json.errors || response.statusText;
      throw new FetchError(msg, response);
    } else {
      response.data = json;
      return response;
    }
  } catch (ex) {
    if (showMessageOnError) {
      NApp.flashNoticeOut(ex.toString(), "error");
    }
    throw ex;
  }
}

const http2 = {
  get: function (url, config = {}) {
    if (!config.responseType || config.responseType === "json") {
      return jsonFetch({
        url,
        method: "GET",
        headers: config.headers,
        params: config.params,
        showMessageOnError: config.showMessageOnError,
      });
    } else {
      return otherFetch({
        url,
        method: "GET",
        headers: config.headers,
        params: config.params,
        responseType: config.responseType,
      });
    }
  },
  patch: function (url, body = {}, config = {}) {
    if (!config.responseType || config.responseType === "json") {
      return jsonFetch({
        url,
        method: "PATCH",
        headers: config.headers,
        params: config.params,
        body,
        showMessageOnError: config.showMessageOnError,
      });
    } else {
      throw Error("Not implemented yet");
    }
  },
  post: function (url, body = {}, config = {}) {
    if (!config.responseType || config.responseType === "json") {
      return jsonFetch({
        url,
        method: "POST",
        headers: config.headers,
        params: config.params,
        body,
        showMessageOnError: config.showMessageOnError,
      });
    } else {
      throw Error("Not implemented yet");
    }
  },
  uploadPost: function (url, name, blob, params, filename) {
    const body = new FormData();
    Object.keys(params || {}).forEach((key) => body.set(key, params[key]));
    body.set(name, blob, filename);
    return otherFetch({
      url,
      method: "POST",
      body,
      responseType: "json",
    });
  },
  delete: function (url, body = {}, config = {}) {
    if (!config.responseType || config.responseType === "json") {
      return jsonFetch({
        url,
        method: "DELETE",
        headers: config.headers,
        params: config.params,
        body,
        showMessageOnError: config.showMessageOnError,
      });
    } else {
      throw Error("Not implemented yet");
    }
  },
};

export default http2;
